module.exports = __webpack_public_path__ + "media/images/icon/chevron-down-yellow-89bcb680bb58a07d5d9b568a1d800e27.svg";